export default "__VITE_ASSET__Bh_aGHHC__"